<template>
  <el-button size="small" plain style="margin: 0px" @click="handlePreview">
    {{ $t('ad.preview') }}
  </el-button>

  <div v-if="visible" class="container" @click="event => handleClose(event)">
    <div :class="['main', 'cards-' + limit]">
      <template v-for="item, index in material">
        <div v-if="isVideo(item.url)" style="display:flex; align-items: center; background-color: #000;">
          <video style="vertical-align: bottom;" :src="item.url" autoplay></video>
        </div>
        <el-image v-else :src="item.url" fit="cover" />
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { isVideo, timeToNumber } from './utils'

export default defineComponent({
  name: 'Preview',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup(props) {

    const limit = ref(0)
    const material = ref<any[]>([])
    const visible = ref(false)
    const playList: any[] = []
    let timer: any = null
    let index = 0;

    const handlePreview = () => {
      visible.value = true
      document.body.style.overflow = 'hidden'
      start()
    }

    const start = () => {
      if (index > playList.length - 1) {
        index = 0
      }
      const { cards, duration } = playList[index]
      material.value = cards.map((item: any) => ({ ...item, url: `${item.url}?t=${new Date().getTime()}` }))
      console.log('material.value: ', material.value);
      console.log('cards: ', cards);
      limit.value = cards.length
      timer = setTimeout(() => {
        index++
        start()
      }, duration * 1000)
    }

    const handleClose = (event: MouseEvent) => {
      const el = event.target as HTMLElement
      if (el.classList.contains('container')) {
        index = 0
        clearTimeout(timer)
        visible.value = false
        document.body.style.overflow = 'auto'
      }
    }

    watch(props, () => {
      playList.length = 0
      const periods = props.data.period || []
      periods.forEach((period: any) => {
        const material = period.material || []
        material.forEach((item: any) => {
          playList.push({ cards: item.cards, duration: timeToNumber(item.duration) })
        })
      })
    }, { immediate: true })

    return {
      limit,
      material,
      visible,
      handleClose,
      handlePreview,
      isVideo
    }
  }
})

</script>

<style scoped lang="scss">
.container {
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999999;
}

.main {
  width: 388px;
  height: 726px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #000;
}

.cards-1,
.cards-2,
.cards-3 {
  flex-direction: column;
  justify-content: flex-start;

  video {
    width: 100%;
  }

  .el-icon {
    transform: translateY(160px);
  }
}

.cards-1 {
  div:nth-child(1) {
    height: 100%;
    width: 100%;
  }
}

.cards-2 {
  div:nth-child(1) {
    height: 242px;
    width: 100%;
  }

  div:nth-child(2) {
    height: 484px;
    width: 100%;
    margin-left: 0 !important;
  }
}

.cards-3 {
  div:nth-child(1) {
    height: 242px;
    width: 100%;
  }

  div:nth-child(2) {
    height: 242px;
    width: 100%;
  }

  div:nth-child(3) {
    height: 242px;
    width: 100%;
  }
}
</style>